import { Participant } from "./Participant";

export class Role extends Participant {
    public dbID: number;
    public name: string;

    constructor(dbID: string, name: string) {
        super();

        const parsedDbId = Number(dbID);

        if (isNaN(parsedDbId))
            throw new Error(`Could not parse dbID of Role participant '${name}'!\nUnparsed value is '${dbID}'...`);

        this.dbID = parsedDbId;
        this.name = name;
    }
}
